import React, { useEffect } from 'react';
import './Docs.css';
import triangle from '../assets/triangle_bleu.png';
import pdf from '../assets/pdf.png';

function Docs() {

    const isBeforeNouveauDeadline = new Date() < new Date('2026-10-30');

    const charges = [
        'Cahier des charges Pro - Saison 2026-2027'
    ]

    const calendriers = [
        'Calendrier Officiel Pro A Messieurs 2026-2027',
        'Calendrier Officiel Pro A dames 2026-2027',
        'Calendrier officiel Pro B Messieurs 2026-2027',
        'Calendrier Officiel Pro B Dames 2026-2027',
    ]
    
    const listes_pro = [
    ]

    const referents = [
        'Liste référents Pro A Messieurs 2026-2027',
        'Liste des référents Pro A dames 2026-2027',
        'Liste référents Pro B Messieurs 2026-2027',
        'Liste référents Pro B dames  2026-2027'
    ]

    const tenues = [
    ]

    const livescoring = [
        'Tutoriel Livescoring',
        'Comment diffuser la rencontre sur Youtube',
    ]

    
    const sections = [
        {id: 1, title: "Cahier des charges", folder: "", data: charges},
        {id: 2, title: "Calendriers officiels", folder: "calendrier/", data: calendriers},
        {id: 3, title: "Listes Pro", folder: "listes/", data: listes_pro},
        {id: 4, title: "Listes des référents", folder: "referents/", data: referents},
        {id: 5, title: "Tenues Sportives", folder: "tenues/", data: tenues},
        {id: 6, title: "Livescoring", folder: "", data: livescoring},
    ]

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const goToPDF = (e, link) => {
        e.preventDefault();
        window.open(link, '_blank');
    }

    return ( 
        <div className="docs_page">
            {/* // BANNIERE */}
            <div className={"top_banniere actus"}>
                <span className="top_banniere_title">
                    Documentation
                </span>
            </div>
            <div className="docs_content">
                {
                    sections.map((item) => {
                        return (
                            item.data.length > 0 &&
                            <div key={item.id} className="docs_items" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                <h1>
                                    {item.title}
                                </h1>
                                <div className="docs_documents">
                                    {
                                        item.data.map((title, index) => {
                                            return (
                                                <div>
                                                    <div key={index} style={{display: 'flex', alignItems: 'center', width: '100%'}}>
                                                        <a href={process.env.PUBLIC_URL + '/docs/' + item.folder + title + '.pdf'} target='_blank'>
                                                            <img src={triangle} style={{marginRight: 20}} />
                                                            {
                                                                title
                                                            }
                                                            {
                                                                title.includes('2027') && isBeforeNouveauDeadline &&
                                                                <span className="badge_nouveau">Nouveau</span>
                                                            }
                                                        </a>
                                                        <img src={pdf} style={{cursor: 'pointer'}} width="64" height="64" onClick={(e)=>goToPDF(e, process.env.PUBLIC_URL + '/docs/'+title+'.pdf')} />
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            ||
                            <div key={item.id} className="docs_items" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                <h1>
                                    {item.title}
                                </h1>
                                <div className="docs_documents" style={{textAlign: 'center'}}>
                                    Aucun document disponible
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    );
}

export default Docs;
